import React, { Component } from 'react';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';

class Navigator extends Component {
  render() {
    if (this.props.routeName) {
      return <Redirect to={this.props.routeName} />;
    }
    return null;
  }
}

Navigator.propTypes = {
  routeName: PropTypes.string,
};

Navigator.defaultProps = {
  routeName: null,
};

export default Navigator;
